import React, { useState, useEffect } from 'react';
import { ShieldCheck, Calendar } from 'lucide-react';
import { Certificate } from '../../types';

export const CertificateManager: React.FC = () => {
  const [certs, setCerts] = useState<Certificate[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/v1/pto/certificates')
      .then(r => r.json())
      .then(d => {
        if (d.success) setCerts(d.data);
      })
      .finally(() => setLoading(false));
  }, []);

  const getDocTypeBadge = (type: string) => {
    switch (type) {
      case 'fire_safety':
        return <span className="bg-rose-50 text-rose-700 border border-rose-200 text-[10px] font-bold px-2 py-0.5 rounded-md">Пожарный сертификат</span>;
      case 'quality_passport':
        return <span className="bg-amber-50 text-amber-700 border border-amber-200 text-[10px] font-bold px-2 py-0.5 rounded-md">Паспорт качества</span>;
      default:
        return <span className="bg-emerald-50 text-emerald-700 border border-emerald-200 text-[10px] font-bold px-2 py-0.5 rounded-md">Сертификат соответствия</span>;
    }
  };

  return (
    <div className="space-y-4">
      <div className="bg-white p-4 rounded-2xl border border-slate-200/90 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] flex items-center justify-between">
        <div>
          <h2 className="text-base font-bold text-slate-900 flex items-center gap-2">
            <span className="p-2 bg-emerald-50 text-emerald-700 border border-emerald-200 rounded-xl">
              <ShieldCheck className="w-5 h-5" />
            </span>
            <span>База сертификатов и паспортов качества материалов</span>
          </h2>
          <p className="text-xs text-slate-500 mt-1">
            Сертификаты соответствия на кабели ГОСТ, лотки и автоматику для привязки к АОСР
          </p>
        </div>
      </div>

      {loading ? (
        <div className="p-8 text-center text-slate-400 text-sm">Загрузка сертификатов...</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {certs.map((c) => (
            <div key={c.id} className="bg-white border border-slate-200/90 hover:border-slate-300 p-4 rounded-2xl space-y-2 transition shadow-sm">
              <div className="flex items-center justify-between gap-2">
                <span className="text-xs font-mono font-black text-amber-700">{c.certNumber}</span>
                {getDocTypeBadge(c.docType)}
              </div>

              <h3 className="text-sm font-bold text-slate-900">{c.title}</h3>
              <p className="text-xs text-slate-500">Изготовитель: <strong className="text-slate-700">{c.manufacturer}</strong></p>

              <div className="flex items-center justify-between pt-2 border-t border-slate-100 text-[11px] text-slate-500">
                <span className="flex items-center gap-1 font-medium">
                  <Calendar className="w-3.5 h-3.5 text-slate-400" />
                  Действует до: <strong className="text-emerald-700">{c.validUntil}</strong>
                </span>
                <span className="text-blue-700 font-bold">Активен</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
